export const routePermissions = {
  "/steam": "steam",
  "/mindshare": "mind-share",
  "/tiktok": "tik-tok",
  "/mobile": "mobile",
  "/calendar": "calendar",
  "/game/:app_id": "steam",
  "/followers": "steam",
  "/search": "steam",
  "/steam-mobile": "steam",
  "/scorecards": "scorecards",
  "/country": "country",
  "/twitch": "twitch",
  "/discord": "discord",
  "/youtube": "youtube",
  "/xbox": "xbox",
  "/roblox": "roblox",
};
